import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { LoginService } from 'app/providers/login.provider';
import { Router } from '@angular/router';

@Component({
    selector     : 'forgot-password-2',
    templateUrl  : './forgot-password-2.component.html',
    styleUrls    : ['./forgot-password-2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class ForgotPassword2Component implements OnInit
{
    forgotPasswordForm: FormGroup;
    loading:boolean = false;
    msjError = '';
    errorMsjOk = ''
    credentialError = false;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _loginService: LoginService,
        private router: Router,
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.forgotPasswordForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });
    }

    /**
     * Valid credentetials
     */
    recoverCredential(): void {
        this.loading = true;
        this.msjError = '';
        this.credentialError = false;

        setTimeout(() => {
            if (this.forgotPasswordForm.valid) {
                this._loginService.recoverCredential(this.forgotPasswordForm.value).subscribe(
                    (res) => {
                        //this.settingApp.setUserSetting('name', data.nk.replace('/\b\w/g', l => l.toUpperCase()));
                        //this.router.navigate(['pages/auth/mail-confirm'])
                        this.loading = false;
                        this.forgotPasswordForm.reset();
                        this.errorMsjOk = 'Correo de restauración enviado correctamente'
                    },
                    (error) => {
                        console.log(error);
                        this.msjError = error.error.error;
                        this.credentialError = true;
                        this.loading = false;
                    }
                );
            }
            
        }, 2000);
    }
}
